import { isEmpty } from 'lodash';

import { PullRequestResponse } from 'hooks/useVersionControl/types';
// @ts-ignore
import { getEntitiesList } from 'store/services/entities/actions';
// @ts-ignore
import { getIntentsList } from 'store/services/intents/actions';
// @ts-ignore
import { getContextsList } from 'store/services/contexts/actions';
// @ts-ignore
import { getRuleGroupsList } from 'store/services/ruleGroups/actions';
// @ts-ignore

export type RefreshNLUState = (
  pullResponse?: PullRequestResponse,
) => (dispatch: unknown, getState: unknown) => void;

export const refreshNLUState: RefreshNLUState = pullResponse => (
  dispatch,
  getState,
) => {
  if (pullResponse) {
    Object.keys(pullResponse).forEach(key => {
      if (
        !isEmpty(pullResponse[key as keyof PullRequestResponse]) &&
        getEntitiesList &&
        getIntentsList &&
        getRuleGroupsList &&
        getContextsList
      ) {
        switch (key) {
          case 'entity':
            getEntitiesList()(dispatch, getState);
            break;
          case 'intent':
            getIntentsList()(dispatch, getState);
            break;
          case 'rule_group':
            getRuleGroupsList()(dispatch, getState);
            break;
          case 'context':
            getContextsList()(dispatch, getState);
            break;
          default:
            break;
        }
      }
    });
  }
};

export default refreshNLUState;
